<template>
  <div class="role-change">
    <div class="banner">
      <div class="title">
        <span>请选择角色</span>
        <div class="line"></div>
      </div>
    </div>
    <div class="card">
      <template v-if="distributor.length > 0">
        <div class="list" v-for="(item, index) in distributor" :key="item.id">
          <div class="title" v-if="index === 0">经销商角色</div>
          <div
            class="button"
            :class="{ 'active-botton': item.id == currentId }"
            @click="btnLogin(item.id)"
          >
            {{ item.storeName || item.customerName }}
          </div>
        </div>
      </template>
      <template v-if="shopowner.length > 0">
        <div class="list" v-for="(item, index) in shopowner" :key="item.id">
          <div class="title" v-if="index === 0">店长角色</div>
          <div
            class="button"
            :class="{ 'active-botton': item.id == currentId }"
            @click="btnLogin(item.id)"
          >
            {{ item.storeName || item.customerName }}
          </div>
        </div>
      </template>
      <template v-if="guide.length > 0">
        <div class="list" v-for="(item, index) in guide" :key="item.id">
          <div class="title" v-if="index === 0">导购角色</div>
          <div
            class="button"
            :class="{ 'active-botton': item.id == currentId }"
            @click="btnLogin(item.id)"
          >
            {{ item.storeName || item.customerName }}
          </div>
        </div>
      </template>
      <template v-if="newUser.length > 0">
        <div class="list" v-for="(item, index) in newUser" :key="item.id">
          <div class="title" v-if="index === 0">新信息（登录后获取身份）</div>
          <div
            class="button"
            :class="{ 'active-botton': item.id == currentId }"
            @click="btnLogin(item.id)"
          >
            {{ item.storeName || item.customerName }}
          </div>
        </div>
      </template>
      <template v-if="department.length > 1">
        <div class="list" v-for="(item, index) in department" :key="item.saleShopCode">
          <div class="title" v-if="index === 0">部门选择</div>
          <div
            class="button"
            :class="{ 'active-botton': item.saleShopCode == currentCode }"
            @click="changeDep(item)"
          >
            {{ item.saleShopName}}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import loadingMixin from "@/mixins/loading-mixin";
export default {
  mixins: [loadingMixin],
  data() {
    return {
      currentId: 0,
      currentCode: 0,
      isFirst: true,
      // 经销商
      distributor: [],
      // 店长
      shopowner: [],
      // 导购
      guide: [],
      // 部门
      department: [],
      // 新用户
      newUser: [],
    };
  },
  created() {
    let userList = this.$cache.getLoginUserList();
    if (userList && userList.length) {
      this.showLoading();
      userList.forEach((item) => {
        if (item.roleCode == 1) {
          this.distributor.push(item);
        } else if (item.roleCode == 2) {
          this.shopowner.push(item);
        } else if (item.roleCode == 3) {
          this.guide.push(item);
        } else {
          this.newUser.push(item);
        }
      });
      this.hideLoading();
    }
  },
  methods: {
    btnLogin(id) {
      if (this.isFirst) {
        this.showLoading();
        this.currentId = id;
        let wxToken = this.$cache.getLoginInfo().wxToken;
        this.isFirst = false;
        let parmes = {
          userId: id,
          wxToken,
          flag: this.$cache.is365() ? 2 : 1
        };
        this.$api.common.confirmLoginUser(parmes)
          .then(async _ => {
            const res = await this.$api.h5.userSaleShopInfo()
            this.department = res.data || []
            if (this.department.length <= 1) {
              await store.dispatch("getUserInfo");
              this.redirect();
            } else {
              this.$toast("请选择部门")
            }
            this.isFirst = true;
          })
          .finally(_=> {
            this.hideLoading();
            this.isFirst = true;
          });
      }
    },
    changeDep(item) {
      this.showLoading();
      this.$api.h5.setSaleShop(item)
        .then(async res => {
          await store.dispatch("getUserInfo");
          this.redirect();
        }) .finally(_=> {
            this.hideLoading();
          });
    },
    redirect() {
      this.$router.replace({ path: "/home" });
    }
  }
};
</script>

<style lang="stylus" scoped>
.role-change {
	position: relative;
	.banner {
		width: 100%;
		height: 318px;
		background: url('../../assets/images/role-banner.png');
		background-size: 100% 100%;
		overflow: hidden;
		.title {
			color: #FFFFFF;
			font-size: 32px;
			font-weight: 500;
			margin-top: 87px;
			margin-left: 37px;
			.line {
				width: 46px;
				height: 2px;
				margin-top: 25px;
				background: #F7F8F8;
			}
		}
	}
	.card {
		position: absolute;
		top: 210px;
		width: 100%;
		height: 66vh;
		padding: 25px;
		box-sizing: border-box;
		background: #FFFFFF;
		border-radius: 17px;
		overflow: hidden;
		overflow: auto;
		box-shadow: 1px 3px 11px 1px rgba(187,187,187,0.4000);
		.list {
			.title {
				color: #B7B7B7;
				font-size: 13px;
				margin-top: 18px;
			}
			.button {
				width: 100%;
				padding: 10px 22px;
				box-sizing: border-box;
				color: #FF6A59;
				font-size: 13px;
				font-family: FZLanTingHei-M-GBK;
				border-radius: 6px;
				text-align: center;
				border: 1px solid #F53F4C;
				background: rgba(255,106,89,0.1000);
				margin-top: 11px;
			}
			.active-botton {
				color: #FFFFFF;
				background: #F53F4C;
			}
		}
	}
}
</style>
